import type { GraphQLError, GraphQLFormattedError } from "graphql";

export function formatCompactNumber(
  number: number | bigint,
  locale: string,
  limit = 200000000000000000n,
): string {
  return new Intl.NumberFormat(locale, {
    notation: "compact",
    compactDisplay: "short",
    useGrouping: true,
    maximumSignificantDigits: 3,
    maximumFractionDigits: 1,
  }).format(number > limit ? limit : number);
}

export function prettifyGraphqlError(
  errors:
    | readonly (GraphQLError | GraphQLFormattedError)[]
    | GraphQLError
    | GraphQLFormattedError
    | undefined
    | null,
): string {
  console.log(errors);

  if (errors === undefined || errors === null) {
    return "Unknown error";
  }

  if (Array.isArray(errors) || errors instanceof Array) {
    return errors.map((error) => error.message).join(", ");
  }

  return errors.message.replace(/_/g, " ");
}

export function trimTestPhoneNumberPart(phoneNumber: string): {
  real: string;
  test: string;
} {
  const matches = phoneNumber.match(/(.*?)(\$.*)?$/);

  return {
    real: matches?.[1] ? matches[1] : phoneNumber,
    test: matches?.[2] ? matches[2] : "",
  };
}
